import React, { useRef, useState, useEffect } from 'react';
import Appearance from 'styles/Appearance.js';
import { VelocityComponent } from 'velocity-react';

const BoolToggle = ({ color, disabled, enabled, isEnabled, labelStyle, onChange, requireInteraction, style }) => {

    const ref = useRef(null);
    const [left, setLeft] = useState(0);
    const [opacity, setOpacity] = useState(0);
    const [status, setStatus] = useState(isEnabled);

    const hasValidStatus = () => {
        if(requireInteraction === true) {
            return typeof(status) === 'boolean';
        }
        return true;
    }

    const onRevokeInteraction = () => {
        setStatus(null);
        if(typeof(onChange) === 'function') {
            onChange(null);
        }
    }

    const onToggleClick = val => {
        setLeft(val ? (ref.current.clientWidth / 2) : 0);
        setStatus(val);
        if(typeof(onChange) === 'function') {
            onChange(val);
        }
    }

    useEffect(() => {
        setStatus(isEnabled);
    }, [isEnabled]);

    useEffect(() => {
        setOpacity(hasValidStatus() ? 1 : 0);
    }, [status]);

    useEffect(() => {
        setLeft(hasValidStatus() && status === true ? (ref.current.clientWidth / 2) : 0);
    }, [ref.current, status]);

    return (
        <div style={{
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'row',
            position: 'relative',
            width: '100%',
            ...style
        }}>
            <div
            ref={ref}
            style={{
                border: `2px solid ${Appearance.colors.softBorder()}`,
                borderRadius: 20,
                boxShadow: Appearance.boxShadow(),
                display: 'flex',
                height: 40,
                flexDirection: 'row',
                margin: 'auto',
                overflow: 'hidden',
                position: 'relative',
                width: '100%'
            }}>
                <VelocityComponent
                easing={[250, 20]}
                duration={500}
                animation={{
                    left: left,
                    opacity: opacity
                }}>
                    <div
                    className={'cursor-pointer'}
                    onClick={onToggleClick.bind(this, false)}
                    style={{
                        alignItems: 'center',
                        backgroundColor: color || Appearance.colors.primary(),
                        borderRadius: 20,
                        display: 'flex',
                        height: '100%',
                        justifyContent: 'center',
                        position: 'absolute',
                        width: '50%'
                    }}>
                        <span style={{
                            fontFamily: 'Zen Dots',
                            fontSize: 12,
                            fontWeight: 500,
                            ...labelStyle,
                            color: 'white'
                        }}>{status ? enabled.toUpperCase() : disabled.toUpperCase()}</span>
                    </div>
                </VelocityComponent>
                <div
                className={'cursor-pointer'}
                onClick={onToggleClick.bind(this, false)}
                style={{
                    alignItems: 'center',
                    borderRight: !hasValidStatus() ? `1px solid ${Appearance.colors.softBorder()}` : null,
                    display: 'flex',
                    height: '100%',
                    justifyContent: 'center',
                    width: '50%'
                }}>
                    <span style={{
                        fontFamily: 'Zen Dots',
                        fontSize: 12,
                        fontWeight: 500,
                        ...labelStyle,
                        color: status || !hasValidStatus() ? Appearance.colors.text() : 'white'
                    }}>{disabled.toUpperCase()}</span>
                </div>
                <div
                className={'cursor-pointer'}
                onClick={onToggleClick.bind(this, true)}
                style={{
                    alignItems: 'center',
                    display: 'flex',
                    height: '100%',
                    justifyContent: 'center',
                    width: '50%'
                }}>
                    <span style={{
                        fontFamily: 'Zen Dots',
                        fontSize: 12,
                        fontWeight: 500,
                        ...labelStyle,
                        color: status && hasValidStatus() ? 'white' : Appearance.colors.text()
                    }}>{enabled.toUpperCase()}</span>
                </div>
            </div>
            {requireInteraction && status !== null && (
                <img
                className={'text-button'}
                onClick={onRevokeInteraction}
                src={'images/close-button-light-small.png'}
                style={{
                    height: 25,
                    marginLeft: 8,
                    width: 25
                }} />
            )}
        </div>
    )
}
export default BoolToggle;
